import type BoltMetaArgs from 'types/BoltMetaArgs';
import type { CapiPlp } from 'types/capi/plp';

import BrazeBanner from '~/components/BrazeBanner';
import PageLoadErrorBoundary from '~/components/PageLoadErrorBoundary';
import {
  getAlternateTagsForAllRegions,
  getAlternateTagsForRegions
} from '~/utils/alternateTags';
import seo from '~/utils/seo';

import PlpView, * as plp from '../PlpView';

export default function SneakerPlp() {
  return (
    <>
      <BrazeBanner placementId="plp-top" />
      <PlpView allowNotifications showPromotion />
    </>
  );
}

function isBrandedSmPath(pathname: string) {
  return /\/sole-market\/.+$/.test(pathname);
}

function isNotIndexable(location: Location) {
  const { pathname, search } = location;

  return (
    isBrandedSmPath(pathname) ||
    (pathname.endsWith('/sole-market/') && search.includes('page=')) ||
    search.includes('gender=mens')
  );
}

export const handle = {
  i18n: ['plp']
};

export function ErrorBoundary() {
  return <PageLoadErrorBoundary pageType="plp" />;
}

export const shouldRevalidate = plp.shouldRevalidate;
export { loader } from '../loader.server';

type LoaderData = {
  pageData: CapiPlp;
};

export const meta = (args: BoltMetaArgs<LoaderData>) => {
  const { data, location } = args;

  const meta = data
    ? seo.formatForMeta(data.pageData.canonical_url, data.pageData.seo)
    : [];

  if (isNotIndexable(location)) return seo.addMetaNoIndex(meta);

  const alternates =
    location.pathname === '/release-dates/'
      ? getAlternateTagsForAllRegions(args)
      : getAlternateTagsForRegions(args, data?.pageData.published_region_codes);

  return meta.concat(alternates);
};
